module.exports = __webpack_public_path__ + "static/media/back_nav_bar_icon_1.ade7c8b3.svg";